
<div class="dialog">
  <button class="close d-flex justify-content-between w-100">
    <h3 class="text-center">{{'Sign via QR title' | translate}}</h3>
    <span aria-hidden="true"  (click)="closeDialog()" >&times;</span>
  </button>

  <qrcode [qrdata]="myAngularxQrCode" [width]="256" [errorCorrectionLevel]="'M'"></qrcode>
  <div class="d-flex flex-column align-items-center">
    <p class="body2 color-regular-gray">{{'Sign via QR desc1' | translate}}</p>
    <p class="body2 color-regular-gray">{{'Sign via QR desc2' | translate}}</p>
    <p class="body2 color-regular-gray">{{'Sign via QR desc3' | translate}}</p>
  </div>

</div>
